export const MODELOS = [
  // Mesas Home Office (MES-HO-A..H + variante 2 Gavetas legado)
  'Mesa Home Office Sem Gavetas',
  'Mesa Home Office 1 Gaveta',
  'Mesa Home Office 2 Gavetas',
  'Mesa Home Office Industrial',
  'Mesa Home Office Gabinete',
  'Mesa Home Office Nicho Duplo',
  'Mesa Home Office Nicho e Gaveta',
  'Mesa Bela',
  'Mesa Bela Completa',
  // Mesas em L (MES-L-A..B)
  'Mesa em L',
  'Mesa em L com Gaveteiro',
  // Mesa Dupla (MES-D-A)
  'Mesa Dupla',
  // Mesas de Reunião (MES-R-A..B)
  'Mesa de Reunião com Laterais',
  'Mesa de Reunião Pé Central',
  // Mesas de Jantar (MES-J-A..B)
  'Mesa de Jantar Base Cúbica',
  'Mesa de Jantar Base Alongada',
  // Mesas Cabeceira (MES-CAB-A..F)
  'Cabeceira com Prateleira',
  'Cabeceira com Nicho e 1 Gaveta',
  'Cabeceira com 1 Gaveta e Nicho Inferior',
  'Cabeceira com Nicho e 2 Gavetas',
  'Cabeceira com 2 Gavetas',
  'Cabeceira com 3 Gavetas',
  // Aparadores (APA-A..B)
  'Aparador Básico',
  'Aparador com Prateleira',
  // Estantes Altas Simples (EST-AS-A, B, D — C removida, igual à B com C maior)
  'Estante 4 Andares',
  'Estante 5 Andares',
  'Estante com 2 Portas Inferiores',
  // Estantes Altas Médias (EST-AM-A..F)
  'Estante Assimétrica 5A 10 espaços',
  'Estante Assimétrica 4A 10 espaços',
  'Estante Assimétrica 5A 13 espaços',
  'Estante Dupla 4 Andares',
  'Estante Dupla 5 Andares',
  'Estante Tripla 5 Andares',
  // Estantes Baixas (EST-B-A..D)
  'Estante Baixa 3 Andares',
  'Estante Baixa Dupla 3 Andares',
  'Estante Baixa Assimétrica',
  'Estante Baixa Quádrupla',
  // Nichos (NIC-A..F)
  'Nicho Quadrado',
  'Nicho Retangular',
  'Nicho Vertical com Prateleira',
  'Nicho Horizontal com Divisória',
  'Nicho com Porta Basculante',
  'Nicho Duplo com 2 Portas Basculantes',
  // Especiais
  'Estante com Mesa Conjugada',
  'Armário Estante 4 Andares',
  'Armário Estante 5 Andares',
  // Roupeiros 2 Portas (ROUP-2P-A..F) — 3P/4P removidos (orçáveis via adicionais)
  'Roupeiro 2 Portas Cabideiro e Prateleiras',
  'Roupeiro 2 Portas 5 Espaços',
  'Roupeiro 2 Portas Cabideiro e 7 Nichos',
  'Roupeiro 2 Portas Cabideiro e 2 Gavetas',
  'Roupeiro 2 Portas 4 Espaços e 2 Gavetas',
  'Roupeiro 2 Portas Cabideiro e 3 Gavetas',
  // Maleiros (módulos avulsos pra cima de roupeiros)
  'Maleiro',
  // Cômodas (CM-A, B, D, E — variantes "com Moldura" removidas)
  'Cômoda 4 Gavetas',
  'Cômoda 5 Gavetas',
  'Cômoda 5 Gavetas com Porta',
  'Cômoda Dupla 8 Gavetas',
  // Sapateiras (SAP-A..I)
  'Sapateira Baixa 6 Nichos',
  'Sapateira Baixa 8 Nichos',
  'Sapateira Baixa 1 Porta',
  'Sapateira Baixa 2 Portas',
  'Sapateira Alta 1 Porta',
  'Sapateira Alta 2 Portas',
  'Sapateira Basculante 1 Porta',
  'Sapateira Basculante 3 Portas',
  'Sapateira Basculante Dupla 6 Portas',
  // Baús (BAU-A..D)
  'Baú sem Tampa',
  'Baú com Tampa',
  'Baú Solteiro',
  'Baú Casal',
  // Balcões (BAL-A..D)
  'Balcão Alto Básico',
  'Balcão Alto com Nicho e Gaveta',
  'Balcão Médio com Gaveta e Nicho',
  'Balcão Médio Misto',
  // Buffets 2 Portas (BUF-2P-A, C, D — variante "com Base" removida)
  'Buffet 2 Portas',
  'Buffet 1 Porta com Nicho',
  'Buffet 2 Portas com Espaço Eletro',
  // Buffets 3 Portas (BUF-3P-A, D — variantes "com Base" e "com Moldura+Base" removidas)
  'Buffet 3 Portas',
  'Buffet 3 Portas com Gavetas',
  // Buffets 4 Portas (BUF-4P-A, D — variantes "com Base" e "com Moldura+Base" removidas)
  'Buffet 4 Portas',
  'Buffet 4 Portas Adega',
  // Racks (RACK-A, B, C, E — variantes "com Moldura e Base" e "Thalita com Base/Moldura" removidas)
  'Rack 2 Basculantes e 2 Nichos',
  'Rack Thalita',
  'Rack 4 Portas',
  'Rack 2 Portas e Nicho Duplo Central',
  // Armários Multiuso (ARM-MULT-A..B)
  'Armário Multiuso 2 Portas',
  'Armário Multiuso 1 Porta',
  // Armários Verticais (ARM-VERT-A, B, C renomeado — D removido)
  'Armário Copa',
  'Armário com Nicho Central',
  'Armário 3 Andares e Portas Inferiores',
  // Armários Suspensos (SUSP-A..F)
  'Armário Suspenso 2 Basculantes e 2 Nichos',
  'Armário Suspenso 2 Portas e Basculante',
  'Armário Suspenso 3 Portas',
  'Armário Suspenso 2 Portas e Nicho',
  'Armário Suspenso 3 Portas e Nicho',
  'Armário Suspenso 4 Portas',
  // Gelágua (GEL-A..B)
  'Móvel Gelágua com Fruteira',
  'Móvel Gelágua Fechado',
  // Área de Serviço (AS-A..D)
  'Armário Área de Serviço 2 Portas',
  'Armário Área de Serviço 1 Porta',
  'Armário para Máquina Top Load',
  'Armário para Máquina Front Load',
  // WC (WC-A..D)
  'Carrinho WC com Porta Basculante',
  'Carrinho WC com Porta e Nicho',
  'Carrinho WC Aberto',
  // Gaveteiros (GAV-A..B)
  'Gaveteiro',
  // Carrinhos (CARR-A..B)
  'Carrinho de Café',
  'Carrinho de Café com Gaveta',
]

export const CATEGORIAS_MODELO = {
  'Mesas Home Office': [
    'Mesa Home Office Sem Gavetas',
    'Mesa Home Office 1 Gaveta',
    'Mesa Home Office 2 Gavetas',
    'Mesa Home Office Industrial',
    'Mesa Home Office Gabinete',
    'Mesa Home Office Nicho Duplo',
    'Mesa Home Office Nicho e Gaveta',
    'Mesa Bela',
    'Mesa Bela Completa',
  ],
  'Mesas em L': [
    'Mesa em L',
    'Mesa em L com Gaveteiro',
  ],
  'Mesa Dupla': [
    'Mesa Dupla',
  ],
  'Mesas de Reunião': [
    'Mesa de Reunião com Laterais',
    'Mesa de Reunião Pé Central',
  ],
  'Mesas de Jantar': [
    'Mesa de Jantar Base Cúbica',
    'Mesa de Jantar Base Alongada',
  ],
  'Mesas de Cabeceira': [
    'Cabeceira com Prateleira',
    'Cabeceira com Nicho e 1 Gaveta',
    'Cabeceira com 1 Gaveta e Nicho Inferior',
    'Cabeceira com Nicho e 2 Gavetas',
    'Cabeceira com 2 Gavetas',
    'Cabeceira com 3 Gavetas',
  ],
  'Aparadores': [
    'Aparador Básico',
    'Aparador com Prateleira',
  ],
  'Estantes Altas Simples': [
    'Estante 4 Andares',
    'Estante 5 Andares',
    'Estante com 2 Portas Inferiores',
  ],
  'Estantes Altas Médias': [
    'Estante Assimétrica 5A 10 espaços',
    'Estante Assimétrica 4A 10 espaços',
    'Estante Assimétrica 5A 13 espaços',
    'Estante Dupla 4 Andares',
    'Estante Dupla 5 Andares',
    'Estante Tripla 5 Andares',
  ],
  'Estantes Baixas': [
    'Estante Baixa 3 Andares',
    'Estante Baixa Dupla 3 Andares',
    'Estante Baixa Assimétrica',
    'Estante Baixa Quádrupla',
  ],
  'Nichos': [
    'Nicho Quadrado',
    'Nicho Retangular',
    'Nicho Vertical com Prateleira',
    'Nicho Horizontal com Divisória',
    'Nicho com Porta Basculante',
    'Nicho Duplo com 2 Portas Basculantes',
  ],
  'Especiais': [
    'Estante com Mesa Conjugada',
    'Armário Estante 4 Andares',
    'Armário Estante 5 Andares',
  ],
  'Roupeiros 2 Portas': [
    'Roupeiro 2 Portas Cabideiro e Prateleiras',
    'Roupeiro 2 Portas 5 Espaços',
    'Roupeiro 2 Portas Cabideiro e 7 Nichos',
    'Roupeiro 2 Portas Cabideiro e 2 Gavetas',
    'Roupeiro 2 Portas 4 Espaços e 2 Gavetas',
    'Roupeiro 2 Portas Cabideiro e 3 Gavetas',
  ],
  'Maleiros': [
    'Maleiro',
  ],
  'Cômodas': [
    'Cômoda 4 Gavetas',
    'Cômoda 5 Gavetas',
    'Cômoda 5 Gavetas com Porta',
    'Cômoda Dupla 8 Gavetas',
  ],
  'Sapateiras': [
    'Sapateira Baixa 6 Nichos',
    'Sapateira Baixa 8 Nichos',
    'Sapateira Baixa 1 Porta',
    'Sapateira Baixa 2 Portas',
    'Sapateira Alta 1 Porta',
    'Sapateira Alta 2 Portas',
    'Sapateira Basculante 1 Porta',
    'Sapateira Basculante 3 Portas',
    'Sapateira Basculante Dupla 6 Portas',
  ],
  'Baús': [
    'Baú sem Tampa',
    'Baú com Tampa',
    'Baú Solteiro',
    'Baú Casal',
  ],
  'Balcões': [
    'Balcão Alto Básico',
    'Balcão Alto com Nicho e Gaveta',
    'Balcão Médio com Gaveta e Nicho',
    'Balcão Médio Misto',
  ],
  'Buffets 2 Portas': [
    'Buffet 2 Portas',
    'Buffet 1 Porta com Nicho',
    'Buffet 2 Portas com Espaço Eletro',
  ],
  'Buffets 3 Portas': [
    'Buffet 3 Portas',
    'Buffet 3 Portas com Gavetas',
  ],
  'Buffets 4 Portas': [
    'Buffet 4 Portas',
    'Buffet 4 Portas Adega',
  ],
  'Racks': [
    'Rack 2 Basculantes e 2 Nichos',
    'Rack Thalita',
    'Rack 4 Portas',
    'Rack 2 Portas e Nicho Duplo Central',
  ],
  'Armários Multiuso': [
    'Armário Multiuso 2 Portas',
    'Armário Multiuso 1 Porta',
  ],
  'Armários Verticais': [
    'Armário Copa',
    'Armário com Nicho Central',
    'Armário 3 Andares e Portas Inferiores',
  ],
  'Armários Suspensos': [
    'Armário Suspenso 2 Basculantes e 2 Nichos',
    'Armário Suspenso 2 Portas e Basculante',
    'Armário Suspenso 3 Portas',
    'Armário Suspenso 2 Portas e Nicho',
    'Armário Suspenso 3 Portas e Nicho',
    'Armário Suspenso 4 Portas',
  ],
  'Gelágua': [
    'Móvel Gelágua com Fruteira',
    'Móvel Gelágua Fechado',
  ],
  'Área de Serviço': [
    'Armário Área de Serviço 2 Portas',
    'Armário Área de Serviço 1 Porta',
    'Armário para Máquina Top Load',
    'Armário para Máquina Front Load',
  ],
  'Armários WC': [
    'Carrinho WC com Porta Basculante',
    'Carrinho WC com Porta e Nicho',
    'Carrinho WC Aberto',
  ],
  'Gaveteiros': [
    'Gaveteiro',
  ],
  'Carrinhos': [
    'Carrinho de Café',
    'Carrinho de Café com Gaveta',
  ],
}
